import moment from "moment";

export const getAge = (dateString) => {
  if (dateString !== undefined && dateString !== "") {
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      return age - 1;
    }
    return age;
  }
};

export const formatSafeDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  // Example: toLocaleDateString in Indian format (DD/MM/YYYY)
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

// Helper function to generate a unique code
const getUniqueCode = (length, isAlpha) => {
  return isAlpha
    ? Math.random().toString(36).toUpperCase().slice(-length)
    : new Date().getTime().toString().slice(-length);
};

// Function to generate the Lot Number
export const generateLotNo = (enquiryNo, userId) => {
  const enqNo = enquiryNo?.split("/");
  const posCode =
    userId && userId !== "" && userId !== 0 ? userId : getUniqueCode(5, true); // 5-char alphanumeric code

  const randomCode = getUniqueCode(5, false); // 5-digit timestamp-based code

  return enqNo[2] + enqNo[3] + "S" + posCode + "S" + randomCode;
};

export const formatToDDMMYYYY = (dateInput) => {
  if (!dateInput) return "";

  const formatted = moment(
    dateInput,
    [moment.ISO_8601, "YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY"],
    true,
  );

  return formatted.isValid() ? formatted.format("DD-MM-YYYY") : "";
};

export const getDobFromAge = (age, outputFormat = "DD-MM-YYYY") => {
  const ageValue = Number(age);
  if (!Number.isFinite(ageValue) || ageValue < 0) return "";

  const birthYear = moment().subtract(ageValue, "years").year();
  const formatted = moment(`01-01-${birthYear}`, "DD-MM-YYYY", true);

  return formatted.isValid() ? formatted.format(outputFormat) : "";
};

export const CommaSeprator = (input) => {
  if (input !== null && input !== undefined) {
    let value = input;
    let rupee = value.toString();
    let newRupee = rupee.substring(rupee.length - 3);
    let other = rupee.substring(0, rupee.length - 3);
    if (other !== "") newRupee = "," + newRupee;
    //console.log(newRupee);
    let formatedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
    return formatedValue;
  }
};

export const formatDateIntoYYMMDD = (date) => {
  try {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid Date object provided");
    }

    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("formatDate error:", error.message);
    return ""; // return empty string if invalid input
  }
};

export const getNormalizedQueryParams = (searchParams) => {
  const params = {};
  for (let [key, value] of searchParams.entries()) {
    params[key.toLowerCase()] = value;
  }
  return params;
};

export const iso2Map = {
  "United Arab Emirates": "AE",
  Taiwan: "TW",
  Bahrain: "BH",
  Bangladesh: "BD",
  Bhutan: "BT",
  "Brunei Darussalam": "BN",
  Israel: "IL",
  Jordan: "JO",
  Kuwait: "KW",
  Maldives: "MV",
  Mongolia: "MN",
  Nepal: "NP",
  Oman: "OM",
  Qatar: "QA",
  "Saudi Arabia": "SA",
  Austria: "AT",
  Belgium: "BE",
  "Czech Republic": "CZ",
  Denmark: "DK",
  Estonia: "EE",
  Finland: "FI",
  Greece: "GR",
  Hungary: "HU",
  Iceland: "IS",
  Latvia: "LV",
  Lithuania: "LT",
  Luxembourg: "LU",
  Malta: "MT",
  Netherlands: "NL",
  Norway: "NO",
  Poland: "PL",
  Slovakia: "SK",
  Slovenia: "SI",
  Sweden: "SE",
  Switzerland: "CH",
  France: "FR",
  Spain: "ES",
  Germany: "DE",
  Turkmenistan: "TM",
  Botswana: "BW",
  Comoros: "KM",
  Lesotho: "LS",
  Madagascar: "MG",
  Malawi: "MW",
  Namibia: "NA",
  Swaziland: "SZ",
  Albania: "AL",
  Andorra: "AD",
  Armenia: "AM",
  Belarus: "BY",
  "Bosnia and Herzegovina": "BA",
  Bulgaria: "BG",
  Croatia: "HR",
  Cyprus: "CY",
  Georgia: "GE",
  Ireland: "IE",
  Moldova: "MD",
  Monaco: "MC",
  MONTENEGRO: "ME",
  Romania: "RO",
  Portugal: "PT",
  "San Marino": "SM",
  SERBIA: "RS",
  Ukraine: "UA",
  Kiribati: "KI",
  Tonga: "TO",
  Tuvalu: "TV",
  Vanuatu: "VU",
  "United Kingdom": "GB",
  Mexico: "MX",
  Zimbabwe: "ZW",
  Palau: "PW",
  Nauru: "NR",
  Micronesia: "FM",
  Guyana: "GY",
  Paraguay: "PY",
  Suriname: "SR",
  Canada: "CA",
  Cuba: "CU",
  "Dominican Republic": "DO",
  Guatemala: "GT",
  Haiti: "HT",
  Honduras: "HN",
  NICARAGUA: "NI",
  Argentina: "AR",
  Bolivia: "BO",
  Ecuador: "EC",
  Peru: "PE",
  Uruguay: "UY",
  BAHAMAS: "BS",
  Barbados: "BB",
  Belize: "BZ",
  "Costa Rica": "CR",
  Grenada: "GD",
  Jamaica: "JM",
  Panama: "PA",
  "United States": "US",
  Australia: "AU",
  Japan: "JP",
  Singapore: "SG",
  Thailand: "TH",
  Italy: "IT",
  "South Korea": "KR",
  Malaysia: "MY",
  Brazil: "BR",
  "South Africa": "ZA",
  Kenya: "KE",
  Egypt: "EG",
  Morocco: "MA",
  China: "CN",
  "Hong Kong": "HK",
  Philippines: "PH",
  Vietnam: "VN",
  Cambodia: "KH",
  "Sri Lanka": "LK",
  Russia: "RU",
  Turkey: "TR",
  "New Zealand": "NZ",
  Indonesia: "ID",
};
